// extracted by mini-css-extract-plugin
module.exports = {"module":"AnnouncementList_module__32hnu","content":"AnnouncementList_content__3lniB"};